var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#333D4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 4L19.6331 7.8345L17.6 18H3.2457L1 10.1401V6H18.0495L19.1105 2H23V4H20.7071ZM4.75428 15.9998H15.9604L17.5604 7.99984H2.99997V9.85978L4.75428 15.9998Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 23.0002C8.10457 23.0002 9 22.1047 9 21.0002C9 19.8956 8.10457 19.0002 7 19.0002C5.89543 19.0002 5 19.8956 5 21.0002C5 22.1047 5.89543 23.0002 7 23.0002ZM13 23C14.1046 23 15 22.1046 15 21C15 19.8954 14.1046 19 13 19C11.8954 19 11 19.8954 11 21C11 22.1046 11.8954 23 13 23Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingCart);
export default __webpack_public_path__ + "static/media/icon-shopping-cart.ca97af01a8f7572851a7c5678e3f0203.svg";
export { ForwardRef as ReactComponent };